import { RootState } from '../store';

export const SelectShipment = (state: RootState) => state.shipment;